/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface CurrentUserDTO {
  /** Pulled from the PublicID field, not the id field */
  id: string;
  email: string;
  roleId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  discriminator: number | null;
  /** Assumed to be male, female, other, prefer not to respond I guess */
  gender: string;
}
const CurrentUserDTO = {
  create: (initValues?: Partial<CurrentUserDTO> | null): CurrentUserDTO => {
    const defaults: CurrentUserDTO = {
      id: "",
      email: "",
      roleId: 0,
      firstName: "",
      middleName: "",
      lastName: "",
      discriminator: null,
      gender: "",
    };
    const fixedValues: Partial<CurrentUserDTO> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default CurrentUserDTO;
